import React from "react";
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from "@mui/icons-material/DeleteForever";

interface SectionControllerProp {
    deletable?: boolean,
    saveButtonHandler: () => void,
    deleteButtonHandler?: () => void
}

const SectionController: React.FC<SectionControllerProp> = ({
    saveButtonHandler,
    deleteButtonHandler,
    deletable = true
}) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>

            {deletable && deleteButtonHandler && (
                <IconButton
                    aria-label="delete"
                    onClick={deleteButtonHandler}
                    color="inherit"
                >
                    <DeleteIcon sx={{ color: "var(--ttg-black)", fontSize: '2rem' }} />
                </IconButton>
            )}

            <IconButton
                aria-label="save changes"
                onClick={saveButtonHandler}
                color="inherit"
            >
                <SaveIcon sx={{ color: "var(--ttg-black)", fontSize: '2rem' }} />
            </IconButton>
        </Box>
    );
};

export default SectionController;
